import * as React from 'react'
import { GridCellProps } from "@progress/kendo-react-grid";
import AuditForm from '../../library/form/audit/AuditForm';
import { toast } from 'react-toastify';
import HttpRequest from '../../service/httpService'
import SystemDialog from '../../library/tools/SystemDialog';


export interface IActionProps {
    toolbar?: any;
    showAudit?: boolean;
    showDelete?: boolean;
    showServices?: boolean;

    table?: string;
    schema?: string;
    deleteUrl?: string;
    onDeleteSuccess?(data: any): void

}

/*interface IGrid {
    PatientKeyEncrypted: string,
    onRowClick?(data: any): void
    onRowDoubleClick?(data: any): void
}*/

interface resultType {
    id: any,
    icon: any,
    description: any,
    style: any
}
const isActive = {
    color: 'green'
};
const isInActive = {
    color: 'red'
};
interface kgsState {
    finalObject: resultType[]
}

export class SystemActionCell extends React.Component<GridCellProps & IActionProps> {

    constructor(props: any) {
        super(props)
    }
    state = {
        isAuditFormVisible: false,
        showDialog: false,
        finalObject: [],
    }
    onReviewClose = () => {
        this.setState({ isAuditFormVisible: false })
    }
    onReviewOpen = () => {
        this.setState({ isAuditFormVisible: true })
    }
    onDelete = async () => {
        const DeleteUrl = this.props.deleteUrl + '/' + this.props.dataItem['PrimaryKeyEncrypted'];
        var response = await HttpRequest.delete(DeleteUrl)
        if (response && response.status == 200) {
            toast.success("Successfully Deleted");
            this.props.onDeleteSuccess && this.props.onDeleteSuccess(response);
        }
        else {
            toast.warning("This item cannot be deleted, as there are active records associated with this.");
        }

    }
    CloseDialog = () => {
        this.setState({ ...this.state, showDialog: false })
    }
    ShowDialog = () => {
        this.setState({ ...this.state, showDialog: true })
    }
    serviceList: resultType[] = [];
    getServices = (services: any) => {
        HttpService.get('/ReferenceInsurerClientService')
            .then((response) => {
                const data = response.data.Data;
                let result: any = [];
                this.setState({ finalObject: [] })
                for (var i = 0; i < data.length; i += 1) {
                    let subResult: resultType;
                    subResult = {
                        id: data[i].InsurerClientServiceId,
                        icon: data[i].Icon,
                        description: data[i].Name,
                        style: null
                    }
                    this.serviceList.push(subResult);
                }


                this.props.dataItem.Services.split(';').map((data: string) => {
                    let serviceStyle: any = ""

                    data.split(',').map((value: string, index: number) => {

                        if (index === 0) {
                            if (value === '0') {
                                serviceStyle = isInActive
                            }
                            else if (value === '1') {
                                serviceStyle = isActive
                            }
                        }
                        else {
                            let item = this.serviceList.find((t) => t.id == value.trim());
                            if (item) result.push({
                                description: item.description, icon: item.icon, style: serviceStyle
                            });
                        }
                    })
                })


                this.setState({ finalObject: result })

            })
            .catch((e) => {});
    }
    componentDidMount = () => {
        if (this.props.showServices) {

            this.getServices(this.props.dataItem.Services);
        }
    }
    componentDidUpdate = (prevProps: any, prevState: any) => {

        if (prevProps.dataItem.Services != this.props.dataItem.Services) {
            this.getServices(this.props.dataItem.Services);
        }
    }
    render() {
        let primaryKey = this.props.dataItem['PrimaryKeyEncrypted'] || this.props.dataItem['primaryKeyEncrypted'] || this.props.dataItem[this.props.field as string] || '';
        
        return (<>

            <td >
                <SystemDialog visible={this.state.showDialog} message={'Are you sure you want to delete this record?'} onYes={this.onDelete} onNo={this.CloseDialog} />
                {this.props.showAudit &&
                    <AuditForm visible={this.state.isAuditFormVisible} onClose={this.onReviewClose}
                        primaryKeyEncrypted={primaryKey}
                        table={this.props.table as string}
                        schema={this.props.schema as string} />
                }
                <span className="action-icon">
                    {this.props.toolbar}
                    {this.props.showAudit && <a onClick={this.onReviewOpen} title="Review"><span className="icon icon-review2 s-24"></span></a>}                   
                    {this.props.showDelete && <a onClick={this.ShowDialog} title="Delete"><span className="icon icon-delete1 s-18"></span></a>}
                    {this.props.showServices && <td className="insurer_icon_detail"> {this.state.finalObject.map((item) => <a title={item.description} ><span className={item.icon} style={{ ...item.style }}></span></a>)}</td>}
                </span>
            </td>
        </>);
    }
}